<template>
  <!-- 离职  -->
  <div class="formBox">
    <!--员工基本信息 -->
    <FormTitle titleText="基本信息" />
    <Form
      :disabled="basic"
      ref="formValidate"
      :model="formItem"
      :label-width="150"
      label-position="left"
    >
      <div style="margin-bottom: 15px" class="rowAllBox">
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="姓名">
              <Input placeholder="" v-model="formItem.userName"> </Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="主要职位">
              <Input disabled v-model="formItem.title_position"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="入职日期">
              <Input disabled v-model="formItem.hirevalid" />
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="手机">
              <Input disabled v-model="formItem.mobile" />
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="离职日期" prop="last_working_date">
              <DatePicker
                type="date"
                style="width: 100%"
                v-model="formItem.last_working_date"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="离职原因" prop="quit_reason">
              <Select clearable v-model="formItem.quit_reason" placeholder="">
                <Option
                  v-for="(item, index) in Exit_Reason"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="是否有离职补偿金" prop="whether_severance">
              <Select
                clearable
                v-model="formItem.whether_severance"
                placeholder=""
              >
                <Option
                  v-for="(item, index) in Severance_Payment"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem
              label="离职补偿金总金额"
              v-if="isLZY"
              :prop="formItem.whether_severance == 1 ? 'amount_severance' : ''"
            >
              <Input
                type="number"
                :disabled="isLZN"
                v-model="formItem.amount_severance"
              ></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="是否有重新雇佣资格" prop="eligible_rehire_hrbp">
              <Select
                clearable
                v-model="formItem.eligible_rehire_hrbp"
                placeholder=""
              >
                <Option
                  v-for="(item, index) in Qulified_To_Rehire"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24" class="rowBox">
            <FormItem
              :label="$t('离职补偿金附件')"
              v-if="formItem.whether_severance == 1"
            >
              <j2-FileUP
                ref="file1"
                :disabled="true"
                @handleOK="fileSuc"
                @handleDel="fileDel"
                :file_type="{ resourceType: 'Exit_Severance_Attachment_Hrbp' }"
              ></j2-FileUP>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="当年度未休年假折算方式">
              <Select
                clearable
                :disabled="isLZN"
                v-model="formItem.annual_leave_conversion_way"
                placeholder=""
              >
                <Option
                  v-for="(item, index) in ConversionWay"
                  :value="item.code"
                  :key="index"
                  >{{ item.ch_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="未休年假补偿金额">
              <Input
                type="number"
                :disabled="isLZN"
                v-model="formItem.unused_annual_leavel_compensation_amount"
              ></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="当年度Retention Bonus是否包含在离职补偿金总金额">
              <Select
                :disabled="isLZN"
                clearable
                v-model="formItem.retention_bonus_severance"
                placeholder=""
              >
                <Option
                  v-for="(item, index) in Retention_Bonus_Included"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="代通知金">
              <Input
                type="number"
                v-model="formItem.payment_lieu_notice"
              ></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="一次性伤残补助金">
              <Input
                type="number"
                v-model="formItem.one_time_disability_allowance"
              ></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="医疗补助费">
              <Input type="number" v-model="formItem.medicaid"></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
    </Form>
    <FormTitle titleText="离职事项进度确认" />
    <Form
      :disabled="load"
      ref="formValidate"
      :model="formItem"
      :label-width="150"
      label-position="left"
    >
      <div style="margin-bottom: 15px" class="rowAllBox">
        <Table border :loading="loading" :columns="columns2" :data="data3">
          <template slot-scope="{ row }" slot="file1">
            <span style="cursor: pointer" @click="$donwLoad(row.attachment)">{{
              row.resource_name
            }}</span>
          </template>
        </Table>
        <Page @on-change="pageChange" :total="total" style="margin-top: 15px" />
        <Row type="flex" justify="space-between">
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <FormItem
              label="备注："
              style="margin-top: 25px"
              :label-width="150"
            >
              <Input
                style="margin-left: -70px"
                :disabled="disComment"
                type="textarea"
                v-model="formItem.comment"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
    </Form>
    <div class="btnRight">
      <Button
        :disabled="prevent"
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        >退回</Button
      >
      <Button
        :disabled="prevent"
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        @click="Rejected"
        >驳回</Button
      >
      <Button
        :disabled="prevent"
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        @click="comfConfig"
        >同意</Button
      >
      <Button
        :disabled="prevent"
        class="applyBtnRight"
        type="primary"
        @click="returnPage()"
        >返回</Button
      >
    </div>
    <!-- 审批历史 -->
    <FormTitle :titleText="$t('审批历史')" />
    <Table
      border
      :columns="columns3"
      :data="data4"
      slot="content"
      class="titleDistance"
    >
    </Table>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <Modal
      v-model="showdataRejected"
      title="请填写驳回意见"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">确定</Button>
        <Button @click="cancell2">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataAgree"
      title="请填写审批意见"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">确定</Button>
        <Button @click="cancell1">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      rejectMessage: {},
      spinShow: false,
      //  当前年度未休假折算方式
      ConversionWay: [
        {
          code: "1",
          ch_value: "包含在离职补偿金"
        },
        {
          code: "0",
          ch_value: "不包含在离职补偿金"
        }
      ],
      // 申请成功时接收返回的instrance_id
      instanid: "",
      loading: false,
      prevent: false,
      basic: true,
      load: false,
      isLZN: false,
      isLZY: true,
      date: new DateUtil(),
      empoloyee: false,
      //是否有离职补偿金
      Severance_Payment: [],
      //当年度Retention_Bonus_Included
      Retention_Bonus_Included: [],
      //是否有Rehire资格
      Qulified_To_Rehire: [],
      //离职原因
      Exit_Reason: [],
      formItem: {
        name: "",
        injury_grade: "",
        last_working_date: "",
        quit_reasonL: "",
        whether_severance: "",
        amount_severance: "",
        eligible_rehire_hrbp: ""
      },
      formInline: {},
      jingyexieyi: false,
      //组织信息表格
      userOrgInfoData: {},
      data1: [],
      // 附件事项备注
      matter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data3: [],
      data4: [],
      resourceId_List: [],
      Legal_Entity: [],
      disComment: false
    };
  },
  computed: {
    ruleValidate() {
      return {
        message: [{ required: true, message: this.$t("请填写驳回意见") + "！" }]
      };
    },
    columns3() {
      return [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ];
    },
    columns2() {
      return [
        {
          title: "事项所属部门",
          key: "matter_department",
          align: "center"
        },
        {
          title: "事项",
          key: "item_word_text",
          align: "center"
        },
        {
          title: "确认人",
          key: "be_sure_user",
          align: "center"
        },
        {
          title: "确认时间",
          key: "be_sure_time",
          align: "center"
        },
        {
          title: "联系方式",
          key: "email",
          align: "center"
        },
        {
          title: "备注",
          key: "comment",
          align: "center"
        },
        {
          title: "附件",
          key: "resource_name",
          align: "center",
          slot: "file1"
        }
      ];
    }
  },
  created() {
    // 页面基本信息查询
    this.getApprovalInfo();
    //查询事项确认表
    this.getExitMatter();
    if (this.getQueryVariable("history") == 1) {
      this.disComment = true;
    }
  },
  methods: {
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getExitMatter();
    },
    getExitMatter() {
      let Obj = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instanceId: this.getQueryVariable("instanceId")
      };
      this.loading = true;
      axios.post("/ExitMatter/selectExitMatterInfo", Obj).then(res => {
        this.data3 = res.data;
        for (let i = 0; i < this.data3.length; i++) {
          this.data3[i].be_sure_time
            ? (this.data3[i].be_sure_time = this.date.dateVal(
                this.data3[i].be_sure_time,
                "YYYY-MM-DD"
              ))
            : "";
        }
        this.total = parseInt(res.pageInfo.total);
        this.loading = false;
      });
    },
    getApprovalInfo() {
      let Obj = {
        instanceId: this.getQueryVariable("instanceId")
      };
      axios.post("/Exit/selectExitApprovalInfo", Obj).then(res => {
        this.formItem = res.basicInfo;
        this.Severance_Payment = res.YESORNO;
        this.Retention_Bonus_Included = res.YESORNO;
        this.Qulified_To_Rehire = res.YESORNO;
        this.Exit_Reason = res.QUITREASON;
        this.formItem.hirevalid
          ? (this.formItem.hirevalid = this.date.dateVal(
              this.formItem.hirevalid,
              "YYYY-MM-DD"
            ))
          : "";
        this.data4 = res.logMap;
        this.$nextTick(() => {
          this.getFileNameAndID();
        });
      });
    },
    getFileNameAndID() {
      this.$refs.file1
        ? (this.$refs.file1.resource_id = this.formItem.severance_attachment_hrbp)
        : "";
      this.$refs.file1
        ? (this.$refs.file1.fileName = this.formItem.resource_name)
        : "";
    },
    download() {
      this.$donwLoad(this.formItem.severance_attachment_hrbp);
    },
    // 删除附件
    fileDel(res_id) {
      this.formItem.severance_attachment_hrbp = "";
      this.resourceId_List.push(res_id);
    },
    // 离职补偿金附件、
    fileSuc(res_id) {
      this.formItem.severance_attachment_hrbp = res_id;
    },
    returnPage() {
      //1审批 0 申请
      if (this.getQueryVariable("taskId")) {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      } else {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      }
    },
    comfConfig() {
      this.showdataAgree = true;
    },
    Rejected() {
      this.showdataRejected = true;
    },
    cancell1() {
      this.showdataAgree = false;
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess1() {
      this.showdataAgree = false;
      let arr2 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          type: "B17"
        }
      ];
      this.spinShow = true;
      axios.post("/process/execute", arr2).then(res => {
        if (res) {
          let Obj = {
            instanceId: this.getQueryVariable("instanceId"),
            comment: this.formItem.comment
          };
          axios.post("/Exit/updateComment", Obj).then(res => {});
          this.$Message.info(this.$t("Approval_Completed"));
          this.$router.push(
            "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
          );
        }
        this.spinShow = false;
      });
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          this.showdataRejected = false;
          let arr2 = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.spinShow = true;
          axios.post("/process/execute", arr2).then(res => {
            if (res) {
              this.$Message.info(this.$t("Approval_Completed"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
            this.spinShow = false;
          });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formBox {
  width: 97%;
  margin: auto;
  background: white;
  padding-bottom: 30px;
  border-radius: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.rowBox {
  line-height: 35px;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}
.rowAllBox {
  width: 97%;
  margin: auto;
}
.width {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ExitApproval.vue